import { render, staticRenderFns } from "./CoaPowder.vue?vue&type=template&id=08a7a917&scoped=true&"
import script from "./CoaPowder.vue?vue&type=script&lang=js&"
export * from "./CoaPowder.vue?vue&type=script&lang=js&"
import style0 from "./CoaPowder.vue?vue&type=style&index=0&id=08a7a917&prod&lang=scss&scoped=true&"
import style1 from "./CoaPowder.vue?vue&type=style&index=1&id=08a7a917&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a7a917",
  null
  
)

export default component.exports